import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { getRecentArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const recentArticles = getRecentArticles(3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              游戏评测、深度攻略、开发故事——丰富的游戏内容等你发现
            </p>
          </div>
          <Link
            to="/article/art-1"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            更多文章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {recentArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}